const defaults = {
  lang: "en",
  parentalLevel: "18",
  networkRequestTimeouts: {
    default: 19000,
    geolocation: 10000,
    phoneValidation: 3000,
    checkUsername: 4000,
    activateChannel: 20000,
    eVoucherProvision: 30000
  },
  environment: "development",
  backendHosts: {
    auth: "http://localhost:3000",
    media: "http://localhost:3001",
    settings: "http://localhost:3002",
    reports: "http://localhost:3003",
    payments: "http://localhost:3004",
    phoneValidation: "http://localhost:3005"
  },
  localCache: {
    auth: true,
    layouts: true,
    titles: true,
    search: true,
    feeds: true,
    genres: true,
    devices: true,
    preferences: true,
    memoryCache: true,
    channelevents: true,
    mops: true,
    deepAddOns: true,
    paymentMethodDictionary: true
  },
  shuffleLayoutStaticModules: false,
  parentalControlLevels: ["1", "7", "15", "18"],
  supportedLanguages: [
    "en",
    "fr",
    "ar",
    "hi",
    "ur",
    "ta",
    "ml",
    "te",
    "pa",
    "mr",
    "bn",
    "bho",
    "gu",
    "kn",
    "jp",
    "ja",
    "jpn",
    "tr",
    "tur"
  ],
  platformName: "smarttv",
  appName: "SamsungTV",
  clientType: "samsung-tizen",
  drmTechnology: "playready",
  drmLicenseServer: "http://playready-license.drm.technology/rightsmanager.asmx",
  heartbeatPeriod: 25000,
  filmstripsTimeJump: 10000,
  layoutCacheTime: 21600000,  // 6 hours
  channelEventsCacheTime: 3600000,
  titlesCacheTime: 10800000,
  seasonsCacheTime: 7200000,
  episodesCacheTime: 300000,
  genresCacheTime: 172800000,
  feedsCacheTime: 3600000,
  devicesCacheTime: 3600000,
  userCacheTime: 144000000,
  userPreferencesCacheTime: 900000,
  memoryCacheTime: 300000,
  memoryCacheLimit: 5242880,
  minimumCacheCleanupTime: 300000,
  tokenExpirationTime: 144000000,
  allMopsCacheTime: 86400000,
  deepAddOnsCacheTime: 1800000,
  paymentMethodDictionaryCacheTime: 86400000,
  phoneVerificationDataExpirationTime: 300000,
  requestTimeout: 50,
  maxUserDevices: 5,
  imageWidths: {
    hero: 900,
    heroMain: 840,
    poster: 240,
    screenshot: 450
  },
  securitylevel4K: "2000",
  appVersion: "",
  publicVersion: "",
  playbackAnalytics: {
    accountCode: "parsifalentertainment",
    enableAnalytics: true,
    httpSecure: true,
    libSrc: "https://smartplugin.youbora.com/v6/js/adapters/bitmovin8/6.8.1/sp.min.js",
    libSrcOldModel: "https://smartplugin.youbora.com/v6/js/adapters/samsungavplay/6.8.0/sp.min.js"
  },
  analyticsId: "UA-52364929-21", // Current development analyticsId.
  maxBitrate: 4700000,
  searchConfig: {
    maxResults: 100,
    maxKeywords: 10,
    maxDidYouMean: 1
  },
  identityProviders: {
    facebook: {
      appId: "1096002503902985", // Test app ID
      apiVersion: "v2.10",
      libSrc: "https://connect.facebook.net/en_US/sdk.js",
      permissions: "email"
    }
  },
  jwtCookie: {
    name: "starz-jwt",
    expirationTime: 144000000 // Four hours
  }
};

const services = {
  layout: {
    home: "/v2/layout/home",
    movies: "/v2/layout/movies",
    series: "/v2/layout/series",
    arabic: "/v2/layout/arabic",
    kids: "/v2/layout/kids",
    yuppflix: "/v2/layout/yuppflix",
    discovery: "/v2/layout/discovery",
    ufc: "/v2/layout/ufc",
    blutv: "/v2/layout/blutv",
    premiersports: "/v2/layout/premiersports",
    adsports: "/v2/layout/adsports",
    criclife: "/v2/layout/criclife",
    majidtv: "/v2/layout/majidtv",
    golftv: "/v2/layout/golftv",
    fifa: "/v2/layout/fifa"
  },
  feeds: "/feeds/%s",
  genreId: "/feeds/genre/%s",
  genres: "/genres",
  reports: "/reports",
  support: "/support",
  faqCategories: "/support/categories",
  faq: "/support/faq",
  login: "/v2/login",
  activationLink: "/v1/activationLink",
  signupV1: "/signup",
  signupV2: "/v2/signup",
  ssoSignupV2: "/v2/ssosignup",
  playbackToken: "/playbackEntitlement",
  devices: "/user/devices",
  eVoucherPromotionShown : "/evoucher/promotionShown",
  eVoucherEligibility: "/evoucher/eligibility",
  eVoucherValidation: "/evoucher/validation",
  eVoucherDeviceValidation: "/evoucher/device/validation",
  titles: {
    movies: "/titles/movies/",
    series: "/titles/series/%s",
    seasons: "/titles/series/%s/seasons",
    season: "/titles/series/%s/seasons/%s",
    title: "/titles/%s",
    medias: "/titles/medias",
    seasonepisodes: "/titles/series/%s/seasons/%s/episodes",
    seasonepisode: "/titles/series/%s/seasons/%s/episodes/%s"
  },
  search: "/v2/search",
  mediaList: {
    list: "/mediaLists",
    listId: "/mediaLists/%s",
    mediaTitle: "/mediaLists/%s/titles",
    addMediaListTitle: "/mediaLists/titles",
    removeMediaItem: "/mediaLists/%s/titles/%s",
    heartBeat: "/mediaLists/heartbeat"
  },
  user: {
    user: "/user",
    users: "/users",
    preferences: "/user/preferences",
    billing: "/user/billing",
    subscriptions: "/user/billing/subscription",
    promotions: "/user/billing/promotions",
    paymentMethod: "/user/billing/payment-method",
    subscriptionDeactivation: "/user/billing/subscriptions/deactivation",
    merge: "/user/merge",
    subscriptionsStatus: "/user/addons/subscriptions",
    addonActivation: "/user/addons/subscriptions/activation",
    addonDeactivation: "/user/addons/subscriptions/deactivation",
    validatePin: "/validate-pin",
    generatePin: "/generate-pin",
    loginPin: "/login-pin",
    concurrency : "/user/concurrency"
  },
  billing: {
    paymentActivation: "/activate",
    paymentActivationLink: "/activation/link",
    paymentPlans: "/payment/plans",
    payfortCreditCard: "/payment-processor",
    adyenCreditCard: "/payment-processor-adyen",
    adyenCreditCardTokenization: "/payment-authorization",
    adyenCreditCardAdditionalVerification: "/additional-details",
    adyenCreditCardPaymentDetailsVerification: "/payment-details",
    subscriptions: "/payment/subscriptions",
    subscriptionsCDN: "/payments/payment/subscriptions",
    paypalSetupToken: "/setup-token",
    paypalPaymentToken : "/payment-token"
  },
  events: "/events",
  geolocation: "/geolocation",
  geolocationSpx: "/geolocation/country",
  voucherEligibility: "/voucher-eligibility",
  eVoucherProvision: "/evoucher/provision",
  validatePhone: "/validate-phone",
  samsungPromotionApplied: "/evoucher/samsung/promotion",
  phoneVerification: "/phoneVerification",
  landlineVerification: "/landlineVerification",
  userEligibility: "/userEligibility",
  ebilling: "/ebilling",
  userExists: "/userExists",
  eligibility: "/eligibility",
  usernameCheck: "/usernameCheck",
  password: {
    forgot: "/password/forgot",
    reset: "/password/reset",
    update: "/%s/password/update"
  },
  campaigns: {
    campaigns: "/campaigns",
    eligibility: "/campaigns/eligibility"
  },
  channel: {
    events: "/channel/events",
    config: "/channel/config"
  },
  allMops: {
    general: "/allMops"
  },
  paymentMethod: {
    general: "/payment-method"
  },
  easypaisa: {
    generateEasypaisaOTP: "/generateEasypaisaOTP"
  }
  };
// FIXME Having this hardcoded in the SDK is not correct
const sections = {
  HOME: "home",
  ALL: "all"
};

export default defaults;
export { services, sections };
